// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const preferencesTypes = [
  {
    short_name: 'Explanation of Benefits (EOB)',
    priority_number: 1,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    available_option_ids: [1, 2, 3],
    detail_text:
      "An invoice for every health care service you had, including information about what is covered and what isn't.",
    id: 5,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    user_selected_option_ids: [2],
  },
  {
    short_name: 'Newsletters & Announcements',
    priority_number: 2,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    available_option_ids: [1, 2, 3],
    detail_text:
      'General information about your plan and membership with Brand Health Insurance.',
    id: 6,
    user_selected_option_ids: [1],
  },
  {
    short_name: 'Wellness Communications',
    priority_number: 3,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    available_option_ids: [1, 2, 3],
    detail_text:
      'Wellness tools and resources that are only available to CareFirst members.',
    id: 7,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    user_selected_option_ids: [2, 3],
  },
  {
    short_name: 'Benefit & Coverage Information',
    priority_number: 4,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    available_option_ids: [1, 2, 3],
    detail_text:
      'Important messages from Brand Health Insurance related to plan or doctor changes.',
    id: 8,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    user_selected_option_ids: [1, 2, 3],
  },
  {
    short_name: 'Drug Reminders',
    priority_number: 5,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    available_option_ids: [1, 2, 3],
    detail_text:
      'A notification to let you know when it’s time to refill your prescription.',
    id: 9,
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    user_selected_option_ids: [1, 2, 3],
  },
];
